import { FormControl, FormLabel, MenuItem, Select, Typography } from '@mui/material';
import { ControllerRenderProps, FieldError } from 'react-hook-form';
import { FieldOption } from '../types/FormField';

export interface DropdownFieldProps {
  label?: string;
  disabled?: boolean;
  value: string;
  onChange: ControllerRenderProps['onChange'];
  error?: FieldError;
  name: string;
  readOnly?: boolean;
  options: FieldOption[];
  placeholderValue?: string;
}

export const DropdownField = ({ label, disabled, value, onChange, error, name, options, readOnly = false, placeholderValue }: DropdownFieldProps) => {
  const placeholder = placeholderValue ?? 'Select option';
  return (
    <>
      <FormControl fullWidth size="small">
        {label && (
          <FormLabel id={`${name}-label`} disabled={disabled}>
            {label}
          </FormLabel>
        )}
        <Select
          displayEmpty
          size="small"
          value={value}
          name={name}
          error={!!error}
          labelId={`${name}-label`}
          disabled={disabled}
          onChange={(event) => onChange(event.target.value)}
          readOnly={readOnly}
          renderValue={(selected) => {
            if (!selected || selected.length === 0) {
              return (
                <Typography variant="inherit" color="secondary">
                  {placeholder}
                </Typography>
              );
            }

            return selected;
          }}
        >
          <MenuItem value="">
            <em>{placeholder}</em>
          </MenuItem>
          {options.map((option) => {
            return (
              <MenuItem value={option.value} key={option.value}>
                {option.label || option.value}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      {error && (
        <Typography variant="caption" color="error">
          {error!.message as string}
        </Typography>
      )}
    </>
  );
};
